import { confirmAlert } from "react-confirm-alert";
import { monthNames } from "../../variables/Variables";
import { fire, auth, db } from "../../firebase/index";
import { customLog, deploymentEnvironment } from "../../variables/Variables";

const getToday = (callback) => {
  const today = new Date();

  let todayMonth = today.getMonth();

  callback(today.getDate() + "-" + monthNames[todayMonth]);
};

const cancelSub = async (data, callback) => {
  const subId = data.subId;
  const userId = data.uid;
  const language = data.language;

  const dataToPost = {
    subId: subId,
    uid: userId,
    language: language,
  };

  let url = "";

  if (deploymentEnvironment) {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/cancelLiveSubscription";
    customLog("Live Environment @ cancelLiveSubscription");
  } else {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/cancelTestSubscription";
    customLog("Test Environment @ cancelLiveSubscription");
  }

  let response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(dataToPost),
  });

  if (response !== null) {
    callback(response);
  }
};

const showConfirmAlert = (title, message, buttons) => {
  confirmAlert({
    title: title,
    message: message,
    buttons: buttons,
  });
};

const updateUserDetails = async (paidDate, customerId, planSelected) => {
  //try
  fire
    .database()
    .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
    .update(
      {
        stripeBillingCycleStart: paidDate,
        stripeID: customerId,
        stripePaidPlan: planSelected,
      },
      function(error) {
        if (error) {
          customLog(error);
        } else {
          // window.location.reload();
          setTimeout(() => {
            window.location.href = "/plans";
          }, 3000);
        }
      }
    );
};

const planSubscription = async (dataToPass, callback) => {
  let url = "";
  if (deploymentEnvironment) {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/liveStripeChargeNew3DS";
    customLog("Live Environment @ StripeBtn");
  } else {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/testStripeChargeNew3DS";
    customLog("Test Environment @ StripeBtn");
  }

  await fetch(url, {
    method: "POST",
    body: JSON.stringify(dataToPass),
  })
    .then(async (response) => {
      customLog(response); //resposne from firebase;
      let returnedVal = await response.json();
      if (returnedVal.status === 402) {
        customLog(returnedVal);
        callback(returnedVal.code);
      } else if (response.status === 500) {
        callback(false);
      } else {
        callback(returnedVal);
      }
    })
    .catch((err) => {
      customLog(err);
      callback(false);
    });
};

const pushNewGroupAccounts = async (
  dbGroupMembers,
  groupAccSchema,
  callback
) => {
  //NewSubscription
  //Never subscribe before

  const fireDbGroupAccounts = fire
    .database()
    .ref("groupAccounts")
    .child(auth.currentUser.uid);

  fireDbGroupAccounts.set(groupAccSchema).then(async (response) => {
    const today = new Date();

    const groupMembersKey = fireDbGroupAccounts
      .child("members")
      .push(dbGroupMembers).key;

    await fireDbGroupAccounts.child("members/" + groupMembersKey).update({
      memberUid: groupMembersKey,
      memberEmail: auth.currentUser.email,
      memberAddedOn: today.getTime(),
    });

    const randomKey = fireDbGroupAccounts.child("groupID").push().key;

    await fireDbGroupAccounts.child("groupID").set(randomKey);

    callback(true);
  });
};

const updateExistingGroupAccounts = async (dataToUpdate, callback) => {
  //Update group account, have subscribed before
  const fireDbGroupAccounts = fire
    .database()
    .ref("groupAccounts")
    .child(auth.currentUser.uid);

  fireDbGroupAccounts.child("payment").update(dataToUpdate);

  callback(true);
};

const changePlan = async (data, dataToUpdate, callback) => {
  let url = "";

  customLog(data);
  customLog(dataToUpdate);

  if (deploymentEnvironment) {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/liveUpgradePlan";
  } else {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/testUpgradePlan";
  }

  await fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
  })
    .then(async (res) => {
      await db
        .ref("groupAccounts/" + auth.currentUser.uid + "/payment")
        .update(dataToUpdate);

      customLog(res);
      callback(true);
    })
    .catch((err) => {
      customLog(err);
      callback(false);
    });
};
export {
  getToday,
  cancelSub,
  showConfirmAlert,
  updateUserDetails,
  updateExistingGroupAccounts,
  pushNewGroupAccounts,
  planSubscription,
  changePlan,
};
